import styled from 'styled-components'

export const TestPaymentGradientText = styled.span`
    margin-right: 5px;
    margin-left: 5px;

    background: linear-gradient(90deg, #ff5c00 0%, #ff9a68 40.35%, #6f51f9 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
`
